import React from 'react';
import { Modal, Box, Typography, Button, TextField } from "@mui/material";
import Grid from "@mui/material/Grid2";
import { Form as RBFORM } from 'react-bootstrap';
import CloseIcon from "@mui/icons-material/Close";

import sitesGreyIcon from '../../../assets/images/icon/sites_grey.svg';

export interface CheckRegistrationStatusModalProps {
    checkRegistraionStatusModalOpen: boolean;
    handleCheckRegStatusModalClose: () => void;
    siteInitialValues: any;
    handleGetRegStatusModalOpen: () => void;
}

export const CheckRegistrationStatusModal: React.FC<CheckRegistrationStatusModalProps> = ({
    checkRegistraionStatusModalOpen, handleCheckRegStatusModalClose,
    siteInitialValues, handleGetRegStatusModalOpen
}) => {
    return (
        <Modal
            open={checkRegistraionStatusModalOpen}
            onClose={handleCheckRegStatusModalClose}
            className="AddFeatureM"
        >
            <Box sx={{
                maxWidth: '600px',
                width: '100%',
                margin: '64px auto 0',
                padding: '24px',
                borderRadius: '30px',
                borderColor: '#5A5F60 !important',
                border: '1px solid',
                marginTop: '230px',
                height: "300px"

            }}
            >
                <Typography variant="h6" component="h2" gutterBottom
                    sx={{
                        fontSize: '20px',
                        color: '#E2E3E3',
                        borderBottom: '1px solid #5A5F60',
                        paddingBottom: '10px',
                        marginBottom: '30px',
                    }}
                >
                    Check Registration Status
                    <span onClick={handleCheckRegStatusModalClose}><CloseIcon style={{ float: "right", cursor: "pointer" }}></CloseIcon></span>
                </Typography>

                <Grid size={{ xs: 12, sm: 6 }} sx={{ height: "80px" }} >
                    <Typography
                        variant="h6"
                        component="h2"
                        gutterBottom
                        sx={{
                            fontSize: "20px",
                            color: "#E2E3E3",
                            paddingBottom: "10px",
                            display: "flex",
                            alignItems: "center",
                            gridGap: '8px',
                        }}
                    >
                        <img src={sitesGreyIcon} alt="" width={20} height={20} />
                        {siteInitialValues?.name}
                    </Typography>
                    <RBFORM.Group>
                        <Typography variant="subtitle1"
                            sx={{
                                color: '#B4B7B8',
                                fontSize: '14px',
                            }}
                        > Unique Hardware ID</Typography>
                        <TextField
                            fullWidth
                            variant="outlined"
                            value={siteInitialValues?.uniqueid}
                            placeholder="Enter Unique Hardware ID"
                            className="inputC"
                        />
                    </RBFORM.Group>
                </Grid>

                <Box sx={{ display: "flex", borderTop: "1px solid #5A5F60", paddingTop: '50px', justifyContent: "flex-end", gap: 2 }}>
                    <Button type="button" onClick={handleCheckRegStatusModalClose} variant="outlined" className="hoverBtn"
                        sx={{ color: '#0699CE', textTransform: 'capitalize', height: '41px', lineHeight: '41px', borderColor: '#0B4A62', borderRadius: '25px', fontSize: '14px', fontWeight: '500', }}
                    >
                        Cancel
                    </Button>

                    <Button type="button" onClick={handleGetRegStatusModalOpen} variant="outlined" className="hoverBtn"
                        sx={{
                            color: '#1F2F34', height: '41px', lineHeight: '41px',
                            borderColor: '#0B4A62', background: '#17B2EB',
                            borderRadius: '25px', fontSize: '14px',
                            fontWeight: '500',
                            textTransform: 'capitalize',
                        }}
                    >
                        Check Status
                    </Button>
                </Box>
            </Box>
        </Modal>
    );
};